import store from 'Data/store';

const hasPamOsEnabledFeatures = featureName =>
    store.getState()?.pamOsEnabledFeatures.length &&
    store.getState().pamOsEnabledFeatures.includes(featureName);

export default hasPamOsEnabledFeatures;
